/**
 * Parse a JSON string into a plain object, returning `fallback` for a null/array/primitive result or
 * a parse error. Used by localStorage config readers so a corrupted value can't crash a caller that
 * then reads object properties (e.g. `saved.viewMode`).
 *
 * @param {string|null|undefined|false} raw - the raw JSON string; any falsy value yields the fallback
 * @param {object} [fallback={}] - returned when raw is missing, unparseable, or not a plain object
 * @returns {object}
 */
export function parseJsonObject(raw, fallback = {}) {
  if (!raw) return fallback
  try {
    const parsed = JSON.parse(raw)
    return parsed && typeof parsed === 'object' && !Array.isArray(parsed) ? parsed : fallback
  } catch {
    return fallback
  }
}
